import { defineStore } from 'pinia'
import {
  getTradableDenoms,
  getActiveMarketIds,
  getPerpetualMarkets,
  getUnverifiedDenoms,
  getMarketByIdOrSlug,
  getMarketsWithSummary,
  getExpiryFuturesMarkets
} from './helpers/marketReadModel'
import type { BffDerivativeMarket } from '@shared/types'

type DerivativeMarketStoreState = {
  marketIdsFromQuery: string[]
}

const initialStateFactory = (): DerivativeMarketStoreState => ({
  marketIdsFromQuery: []
})

export const useDerivativeMarketStore = defineStore('derivativeMarket', {
  state: (): DerivativeMarketStoreState => initialStateFactory(),
  getters: {
    marketByIdOrSlug: () => {
      return (marketIdOrSlug: string): undefined | BffDerivativeMarket => {
        const sharedDerivativeStore = useSharedDerivativeStore()

        return getMarketByIdOrSlug(
          sharedDerivativeStore.marketsWithToken as BffDerivativeMarket[],
          marketIdOrSlug
        )
      }
    },

    perpetualMarkets: () => {
      const sharedDerivativeStore = useSharedDerivativeStore()

      return getPerpetualMarkets(
        sharedDerivativeStore.marketsWithToken as BffDerivativeMarket[]
      )
    },

    expiryFuturesMarkets: () => {
      const sharedDerivativeStore = useSharedDerivativeStore()

      return getExpiryFuturesMarkets(
        sharedDerivativeStore.marketsWithToken as BffDerivativeMarket[]
      )
    },

    activeMarketIds: () => {
      const sharedDerivativeStore = useSharedDerivativeStore()

      return getActiveMarketIds(
        sharedDerivativeStore.marketsWithToken as BffDerivativeMarket[]
      )
    },

    tradableDenoms: () => {
      const sharedDerivativeStore = useSharedDerivativeStore()

      return getTradableDenoms(
        sharedDerivativeStore.marketsWithToken as BffDerivativeMarket[]
      )
    },

    unverifiedDenoms: () => {
      const sharedDerivativeStore = useSharedDerivativeStore()

      return getUnverifiedDenoms(
        sharedDerivativeStore.marketsWithToken as BffDerivativeMarket[]
      )
    },

    marketsWithSummary: () => {
      const sharedDerivativeStore = useSharedDerivativeStore()

      return getMarketsWithSummary(
        sharedDerivativeStore.marketsWithToken as BffDerivativeMarket[],
        sharedDerivativeStore.marketsSummary
      )
    }
  },
  actions: {
    setMarketIdsFromQuery(marketIdsFromQuery: string[]) {
      this.marketIdsFromQuery = marketIdsFromQuery
    },

    appendMarketId(marketIdFromQuery: string) {
      const derivativeMarketStore = useDerivativeMarketStore()

      derivativeMarketStore.setMarketIdsFromQuery([
        ...derivativeMarketStore.marketIdsFromQuery,
        marketIdFromQuery
      ])
    }
  }
})
